import React from "react";
import { DialogContent } from "@material-ui/core";
import DialogTitleWithCloseIcon from "../../../../../elements/DialogTitleWithCloseIcon";

import FixedPositionDialog from "../../../../../elements/FixedPositionDialog";
import I18nText from "../../../../../elements/I18nText";

const Dialog = ({ children, invoiceId, onClose }) => (
  <FixedPositionDialog open={true} scroll="body" fullWidth maxWidth="lg">
    <DialogTitleWithCloseIcon onClose={onClose}>
      <I18nText values={{ invoiceId }}>system.billing.invoice.title</I18nText>
    </DialogTitleWithCloseIcon>
    <DialogContent>{children}</DialogContent>
  </FixedPositionDialog>
);

export default Dialog;
